/**
 * Public menu / quick order: variant SKU visibility from API (variant_skus[].is_available).
 */
export function isVariantSkuPubliclyOrderable(sku) {
  return sku != null && sku.is_available !== false
}

/** First SKU guests may add to cart; falls back to first SKU if all marked unavailable (edge case). */
export function defaultPublicVariantSku(skus) {
  if (!Array.isArray(skus) || skus.length === 0) return null
  const orderable = skus.find((s) => isVariantSkuPubliclyOrderable(s))
  return orderable ?? skus[0]
}
